import React from "react";

const SearchBar = ({ onChangeHandler }) => {
  const [value, setValue] = React.useState("");
  return (
    <div className="sidebar-search">
      <div className="input-group wd-btn-group col-12 p0">
        <input
          type="text"
          onChange={(e) => setValue(e.target.value)}
          className="form-control"
          placeholder="Search ..."
          aria-label="Search for..."
        />
        <span className="input-group-btn">
          <button
            className="btn btn-secondary wd-btn-search"
            type="button"
            onClick={() => onChangeHandler(value)}
          >
            <i className="fa fa-search" aria-hidden="true"></i>
          </button>
        </span>
      </div>
    </div>
  );
};

export default SearchBar;
